import BaseService from '../BaseService.js'

export default class BerufService extends BaseService {
  constructor() {
    super('public/mindestlohn/beruf')
  }

  // Berufe (Suchbegriffe) restricted to those with a matching GAV/NAV for the given Einsatzort + Beginn.
  async listMatching(filter) {
    return this.create(filter, '/matching')
  }
}
